import React, { useState, useEffect } from 'react';
import api, { assetUrl } from '../services/api';

const TestHero: React.FC = () => {
  const [heroCards, setHeroCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHeroCards = async () => {
      try {
        console.log('🔍 Loading hero cards...');
        const response = await api.heroApi.getAll();
        const cards = response.data || [];
        console.log('📦 Raw API response:', cards);
        
        const activeCards = cards
          .filter((card: any) => card.is_active === true)
          .sort((a: any, b: any) => (a.display_order || a.order || 0) - (b.display_order || b.order || 0))
          .map((card: any) => ({
            id: card.id,
            heading: card.heading,
            description: card.description,
            image: assetUrl(card.background_image || card.image)
          }));
        
        setHeroCards(activeCards);
        console.log('✅ Processed hero cards:', activeCards);
      } catch (error) {
        console.error('❌ Error loading hero cards:', error);
      } finally {
        setLoading(false);
      }
    };

    loadHeroCards();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-8 bg-black text-white min-h-screen">
      <h1 className="text-3xl font-bold mb-8">Hero Cards Test</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {heroCards.map((card: any, index) => (
          <div key={card.id} className="border border-white/20 rounded-lg p-4">
            <h3 className="text-xl font-semibold mb-2">{card.heading}</h3>
            <p className="text-gray-300 mb-4">{card.description}</p>
            <div className="w-full h-48 bg-gray-800 rounded-lg overflow-hidden">
              <img 
                src={card.image} 
                alt={card.heading}
                className="w-full h-full object-cover"
                onError={(e) => {
                  console.error(`❌ Image failed to load: ${card.image}`);
                  e.currentTarget.src = 'https://via.placeholder.com/400x300/ff0000/ffffff?text=Image+Error';
                }}
                onLoad={() => {
                  console.log(`✅ Image loaded: ${card.image}`);
                }}
              />
            </div>
          </div>
        ))}
      </div>
      {heroCards.length === 0 && (
        <div className="text-center text-gray-400">
          <p>No hero cards found</p>
        </div>
      )}
    </div>
  );
};

export default TestHero;
